import React from 'react';
import { useFragment, graphql } from 'react-relay';
import type { statusCell_softwareCodePage$key } from '@atlassian/jira-relay/src/__generated__/statusCell_softwareCodePage.graphql';
import { PRStatusLozengeFragment } from '../../../../../../../../common/ui/pr-status-lozenge';

type StatusCellProps = {
	statusCellData: statusCell_softwareCodePage$key;
};

const StatusCell = ({ statusCellData }: StatusCellProps) => {
	const data = useFragment(
		graphql`
			fragment statusCell_softwareCodePage on DevOpsPullRequestDetails {
				...prStatusLozenge_softwareCodePage_PRStatusLozengeFragment
			}
		`,
		statusCellData,
	);

	return <PRStatusLozengeFragment prStatusLozengeData={data} />;
};

export default StatusCell;
